module.exports = __webpack_public_path__ + "static/media/other1.b1f7d63e.jpg";